module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Files/File-d65497ce7c35518f5fb2decb54b30f42d4d50ac8a5653e60dab3b38d8e2952a9.svg";